export const GridFilterDate = {
  filter: 'agDateColumnFilter',
  filterParams: {
    comparator: (filterLocalDateAtMidnight, cellValue = null) => {
      if (cellValue == null) { return 0; }
      const cellDate = new Date((new Date(cellValue)).setHours(0));

      if (cellDate.getTime() < filterLocalDateAtMidnight.getTime()) { return -1; }
      if (cellDate.getTime() > filterLocalDateAtMidnight.getTime()) { return 1; }
      return 0;
    },
    filterOptions: [
      'inRange',
      'greaterThan',
      'lessThan',
      'equals',
      'notEqual',
      'blank',
      'notBlank',
    ],
    inRangeInclusive: true,
    buttons: [
      'clear'
    ]
  },
  // valueFormatter: params => new Date(params.value).toLocaleDateString(),
};
